export default "__VITE_ASSET__RXjZmrsO__"